/* eslint-disable @next/next/no-document-import-in-page */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
// import { ArticleJsonLd, NextSeo } from "next-seo";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import Script from "next/script";
import Avatar from "react-avatar";
import { useForm } from "react-hook-form";
import { BiLink } from "react-icons/bi";
import { FaLinkedin } from "react-icons/fa";
import { useQuery } from "react-query";
import {
   FacebookShareButton,
   FacebookIcon,
   LinkedinIcon,
   LinkedinShareButton,
   TwitterShareButton,
   TwitterIcon,
   WhatsappShareButton,
   WhatsappIcon,
} from "react-share";
import * as yup from "yup";
import {
   AuthorDesignation,
   AuthorInfoContainer,
   AuthorName,
   LinkedInIcon,
} from "components/blog-card/blog-card.style";
import { CategoryCard } from "components/blog-card/category-card";
import MoreBlog from "components/blog-card/more-blog";
import { Button } from "components/button";
import { Input } from "components/input";
import { Textarea } from "components/textarea";
import { AppContainer } from "container/app-container";
import { SIngleBlogPageAdvert } from "container/landing-page/blog-page-advert";
import { ShareSection } from "container/landing-page/landing-page.style";
// import { SingleBlogPageAdvert } from "container/landing-page/single-page-blog-advert";
import { NonDashboardWrapper } from "container/non-dashboard-wrapper";
import { useNotify } from "hooks";
import { fetchSingleBlog, singleBlog, unSecuredBlogs, blogComment, likeBlog } from "services/blog";
import { BlogSingleMainContent } from "styles/blog";
import { FlexBlogPage, SimilarBlog, SingleBlogDisplay } from "styles/blog/blog";
import { MainContainer, BlogContainer } from "styles/index/index.style";
import { getSession } from "utils/auth";
import { SwitchMainCategory, SwitchMainHeading } from "utils/blog-category";
import { trimObject } from "utils/generic-utils";

export interface BlogComment {
   name: string;
   email: string;
   content: string;
}

export default function SingleBlog({ details, slug, featured }) {
   const { notify } = useNotify();
   const [post, setPost] = useState<any>([]);
   const [postUrl, setPostUrl] = useState<any>("");
   const [copied, setCopied] = useState<boolean>(false);
   const [isCommenting, setIsCommenting] = useState(false);
   const [isLikeLoading, setIsLikeLoading] = useState(false);
   const [likedBlog, setLikedBlog] = useState(false);

   const schema = yup.object().shape({
      name: yup.string().required("Full Name is a required field"),
      email: yup.string().required("Email is a required field"),
      content: yup.string().required("Please enter your comment"),
   });

   const {
      handleSubmit,
      register,
      formState: { errors },
      reset,
   } = useForm<BlogComment>({
      resolver: yupResolver(schema),
      mode: "onChange",
   });

   const { data, refetch } = useQuery<any>("single-blog-post", () => singleBlog(slug) as any);
   const { data: blogCategory } = useQuery<any>(
      "single-blog-category",
      () => unSecuredBlogs({ category: SwitchMainCategory(details?.data?.data?.categories) }) as any
   );

   useEffect(() => {
      if (details) {
         setPostUrl(window.location.href);
         refetch();
      }
   }, [details]);

   useEffect(() => {
      if (data) {
         setPost(data?.data?.data);
      }
   }, [data]);

   useEffect(() => {
      if (postUrl) {
         setCopied(false);
      }
   }, [postUrl]);

   useEffect(() => {
      const likedBlogStorage = localStorage.getItem("edusko-like-blog");
      const likedBlogStorageId = localStorage.getItem("edusko-like-blog-id");

      if (likedBlogStorageId === post?.id) {
         likedBlogStorage === "true" ? setLikedBlog(true) : setLikedBlog(false);
      } else {
         setLikedBlog(false);
      }
   }, []);

   async function onSubmit(values: BlogComment) {
      try {
         setIsCommenting(true);
         const response: any = await blogComment(
            post?.id,
            trimObject({
               ...values,
            })
         );
         refetch();
         notify({
            message: response.result.message,
            variant: "success",
         });
         setIsCommenting(false);
         reset();
      } catch (err: any) {
         notify({
            message: err.result.message || err.result.custom_message,
            variant: "error",
         });
      } finally {
         setIsCommenting(false);
      }
   }

   const handleLikeBlog = async (id: string) => {
      try {
         setIsLikeLoading(true);
         const response: any = await likeBlog(id as string);
         setLikedBlog(!likedBlog);
         localStorage.setItem("edusko-like-blog", !likedBlog as unknown as string);
         localStorage.setItem("edusko-like-blog-id", post?.id as unknown as string);
         notify({
            message: response.result.message,
            variant: "success",
         });
         refetch();
      } catch (error: any) {
         notify({
            message: error.result.message || error.result.custom_message,
            variant: "error",
         });
      } finally {
         setIsLikeLoading(false);
      }
   };

   let stripedHtml = details?.data?.data?.content?.replace(/<[^>]+>/g, "");
   const pageDescriptionMeta = stripedHtml?.split(".");

   function copy() {
      navigator.clipboard.writeText(window.location.href);
      setCopied(true);
   }

   const similar = blogCategory?.data?.data?.blogPosts?.filter(
      (b) => b.slug !== details?.data?.data?.slug
   );

   return (
      <div>
         <Head>
            <Script
               id="adsbygoogle-init"
               strategy="lazyOnload"
               crossOrigin="anonymous"
               src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7449886307312276"
            />
         </Head>
         <AppContainer
            title={details?.data?.data?.title}
            image={details?.data?.data?.imageUrl}
            description={pageDescriptionMeta[0]}
            slug={typeof window !== "undefined" ? window.location.href : ""}
         >
            <NonDashboardWrapper>
               <MainContainer>
                  <FlexBlogPage>
                     <SingleBlogDisplay>
                        <div className="header-area">
                           <h3 className="category">
                              {SwitchMainHeading(details?.data?.data?.categories)}
                           </h3>
                           <div className="share-icons">
                              <ShareSection>
                                 <div className="share-contents">
                                    <FacebookShareButton className="social-button" url={postUrl}>
                                       <FacebookIcon
                                          iconFillColor="#444444"
                                          bgStyle={{ fill: "#fff", border: "1px solid #495057" }}
                                          style={{
                                             border: "1px solid #495057",
                                             borderRadius: "8px",
                                             width: "25px",
                                             height: "25px",
                                          }}
                                       />
                                    </FacebookShareButton>

                                    <LinkedinShareButton className="social-button" url={postUrl}>
                                       <LinkedinIcon
                                          iconFillColor="#444444"
                                          bgStyle={{ fill: "#fff", border: "1px solid #495057" }}
                                          style={{
                                             border: "1px solid #495057",
                                             borderRadius: "8px",
                                             width: "25px",
                                             height: "25px",
                                          }}
                                       />
                                    </LinkedinShareButton>
                                    <TwitterShareButton className="social-button" url={postUrl}>
                                       <TwitterIcon
                                          iconFillColor="#444444"
                                          bgStyle={{ fill: "#fff", border: "1px solid #495057" }}
                                          style={{
                                             border: "1px solid #495057",
                                             borderRadius: "8px",
                                             width: "25px",
                                             height: "25px",
                                          }}
                                       />
                                    </TwitterShareButton>
                                    <WhatsappShareButton className="social-button" url={postUrl}>
                                       <WhatsappIcon
                                          iconFillColor="#444444"
                                          bgStyle={{ fill: "#fff", border: "1px solid #495057" }}
                                          style={{
                                             border: "1px solid #495057",
                                             borderRadius: "8px",
                                             width: "25px",
                                             height: "25px",
                                          }}
                                       />
                                    </WhatsappShareButton>
                                    <div
                                       className="copy"
                                       style={{
                                          width: "25px",
                                          height: "25px",
                                          borderRadius: "8px",
                                          background: "#fff",
                                          border: "1px solid #495057",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                          marginBottom: "4px",
                                       }}
                                    >
                                       <BiLink onClick={copy} fontSize={20} />
                                    </div>
                                    <p>{copied && "Copied"}</p>
                                 </div>
                              </ShareSection>
                           </div>
                        </div>
                        <div className="heading">{details?.data?.data?.title}</div>
                        {details?.data?.data?.authorName && (
                           <AuthorInfoContainer>
                              <AuthorName>{details?.data?.data?.authorName}</AuthorName>
                              <AuthorDesignation>
                                 {details?.data?.data?.authorDesignation}
                              </AuthorDesignation>
                              <LinkedInIcon
                                 href={`https://${details?.data?.data?.authorLink}`}
                                 target="_blank"
                                 rel="noopener noreferrer"
                              >
                                 <FaLinkedin size={25} />
                              </LinkedInIcon>
                           </AuthorInfoContainer>
                        )}
                        <div className="flex-details">
                           <div className="time-details">
                              <p className="date">
                                 {moment(details?.data?.data?.createdAt).format("D MMMM, YYYY")}
                              </p>
                              <div className="dot" />
                              <p className="read">{details?.data?.data?.readingTime}</p>
                           </div>
                           <div className="reactions">
                              <div
                                 style={{ cursor: "pointer" }}
                                 onKeyDown={() => handleLikeBlog(post?.id)}
                                 onClick={() => handleLikeBlog(post?.id)}
                                 className="likes"
                              >
                                 {isLikeLoading ? (
                                    <CircularProgress color="primary" thickness={5} size={13} />
                                 ) : (
                                    <>
                                       <img src="/icons/like.png" alt="like-icon" />
                                       <p>{post?.likes}</p>
                                    </>
                                 )}
                              </div>
                              <div className="comments">
                                 <img src="/icons/message-circle.png" alt="comment-icon" />
                                 <p>{post?.blogCommentCount}</p>
                              </div>
                           </div>
                        </div>

                        <BlogSingleMainContent>
                           <div
                              className="main-text"
                              dangerouslySetInnerHTML={{
                                 __html: getFirstWords(details?.data?.data?.content),
                              }}
                           ></div>
                        </BlogSingleMainContent>
                        <img className="blog-image" src={details?.data?.data?.imageUrl} alt="" />
                        <BlogSingleMainContent>
                           <div
                              className="main-text"
                              dangerouslySetInnerHTML={{
                                 __html: getLastWords(details?.data?.data?.content),
                              }}
                           ></div>
                        </BlogSingleMainContent>
                        <div className="flex-details">
                           {details?.data?.data?.authorName && (
                              <AuthorInfoContainer>
                                 <AuthorName>{details?.data?.data?.authorName}</AuthorName>
                                 <AuthorDesignation>
                                    {details?.data?.data?.authorDesignation}
                                 </AuthorDesignation>
                                 <LinkedInIcon
                                    href={`https://${details?.data?.data?.authorLink}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                 >
                                    <FaLinkedin size={25} />
                                 </LinkedInIcon>
                              </AuthorInfoContainer>
                           )}
                           <div className="reactions">
                              <div
                                 style={{ cursor: "pointer" }}
                                 onKeyDown={() => handleLikeBlog(post?.id)}
                                 onClick={() => handleLikeBlog(post?.id)}
                                 className="likes"
                              >
                                 {isLikeLoading ? (
                                    <CircularProgress color="primary" thickness={5} size={13} />
                                 ) : (
                                    <>
                                       <img src="/icons/like.png" alt="like-icon" />
                                       <p>{post?.likes}</p>
                                    </>
                                 )}
                              </div>
                              <div className="comments">
                                 <img src="/icons/message-circle.png" alt="comment-icon" />
                                 <p>{post?.blogCommentCount}</p>
                              </div>
                           </div>
                        </div>
                        <BlogContainer>
                           <h4 className="comment-header">COMMENTS</h4>
                           <>
                              {post?.comments?.map((comment, idx) => (
                                 <div key={idx}>
                                    {comment?.name && (
                                       <div className="blog-display">
                                          <Avatar
                                             size="80"
                                             textSizeRatio={4}
                                             className="comment-avatar"
                                             round={true}
                                             color="#3578E5"
                                             name={`${comment?.name}`}
                                          />
                                          <div className="blog-comment">
                                             <h5>{comment?.name}</h5>
                                             <p>{comment?.content}</p>
                                          </div>
                                       </div>
                                    )}
                                 </div>
                              ))}
                           </>
                           <form style={{ marginTop: "50px" }} onSubmit={handleSubmit(onSubmit)}>
                              <div className="blog-inputs">
                                 <Input
                                    placeholder="Enter Full Name"
                                    id="name"
                                    type="text"
                                    {...register("name")}
                                    error={errors?.name?.message}
                                    name="name"
                                    label="Full Name"
                                 />
                                 <Input
                                    placeholder="Enter Email"
                                    type="text"
                                    {...register("email")}
                                    error={errors?.email?.message}
                                    name="email"
                                    label="Email"
                                    id="email"
                                 />
                              </div>
                              <div className="blog-textarea">
                                 <Textarea
                                    placeholder="Enter comment"
                                    {...register("content")}
                                    error={errors?.content?.message}
                                    name="content"
                                    label="Comment"
                                    id="content"
                                 />
                              </div>
                              <div className="comment-button">
                                 <Button isLoading={isCommenting} type="submit" variant="primary">
                                    Send
                                 </Button>
                              </div>
                           </form>
                        </BlogContainer>
                        <SIngleBlogPageAdvert />
                     </SingleBlogDisplay>
                     <SimilarBlog>
                        <h3 className="similar-article">Similar Articles</h3>
                        {similar?.slice(0, 5)?.map((post, idx) => (
                           <CategoryCard
                              category={SwitchMainCategory(details?.data?.data?.categories)}
                              header={SwitchMainHeading(details?.data?.data?.categories)}
                              key={idx}
                              blog={post}
                           />
                        ))}
                     </SimilarBlog>
                  </FlexBlogPage>
                  <div className="more-heading">More on Edusko</div>
                  {featured?.slice(0, 3)?.map((post, idx): any => (
                     <MoreBlog article={post} key={idx} />
                  ))}
                  <Script
                     id="adsbygoogle-init"
                     strategy="lazyOnload"
                     crossOrigin="anonymous"
                     src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7449886307312276"
                  />
               </MainContainer>
            </NonDashboardWrapper>
         </AppContainer>
         <Script
            id="adsbygoogle-init"
            strategy="lazyOnload"
            crossOrigin="anonymous"
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7449886307312276"
         />
      </div>
   );
}

function getFirstWords(str) {
   return str.split(/\s+/).slice(0, 50).join(" ");
}

function getLastWords(str) {
   return str.split(/\s+/).slice(50, 20000).join(" ");
}

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
   const { token } = getSession(context);
   const slug = context.params?.slug;
   const key = {
      queryKey: ["single-blog-post", slug],
   };

   const details = await fetchSingleBlog(token, key);
   const blogResponse = await unSecuredBlogs({});
   const featuredResponse = await unSecuredBlogs({ isFeatured: "yes" });

   return {
      props: {
         blogs: blogResponse?.data?.data?.blogPosts || null,
         featured: featuredResponse.data?.data?.blogPosts || [],
         details,
         slug,
      },
   };
};
